import { playerSummary } from "@/lib/players";
import { teamStyle } from "@/lib/colors";

export const PlayerSummary = ({ match }) => {
  const { cols, rows } = playerSummary(match);
  if (!rows.length) return <p data-testid="player-summary-empty" className="text-zinc-500 text-sm">Sem eventos de jogadores.</p>;
  return (
    <div className="overflow-x-auto -mx-3 px-3 sm:mx-0 sm:px-0">
      <table data-testid="player-summary" className="w-full min-w-[520px] text-sm border-y border-white/10">
        <thead>
          <tr className="border-b border-white/15 text-left">
            <th className="py-2 pr-3 label-caps">Jogador</th>
            {cols.map((t) => (
              <th key={t.key} className="py-2 px-2 text-center" title={t.label}>
                <span className="px-1.5 py-0.5 font-display font-bold text-xs whitespace-nowrap" style={{ background: t.color, color: t.text }}>{t.short}</span>
              </th>
            ))}
            <th className="py-2 px-2 label-caps text-center">Entrou</th>
            <th className="py-2 px-2 label-caps text-center">Saiu</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-white/10">
          {rows.map((r) => (
            <tr key={`${r.team}-${r.number}`} data-testid={`player-row-${r.team}-${r.number}`}>
              <td className="py-2 pr-3 whitespace-nowrap">
                <span className="inline-flex w-9 h-8 items-center justify-center font-display text-lg font-bold mr-2" style={teamStyle(match[r.team])}>{r.number}</span>
                <span className="text-zinc-400">{match[r.team].name}</span>
              </td>
              {cols.map((t) => <td key={t.key} className="py-2 px-2 text-center font-display text-lg font-bold">{r.counts[t.key] || <span className="text-zinc-700">·</span>}</td>)}
              <td className="py-2 px-2 text-center text-zinc-300">{r.in || "—"}</td>
              <td className="py-2 px-2 text-center text-zinc-300">{r.out || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
